/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
export type StatusFragment = {
  readonly __typename: "Status";
  readonly id: c.StatusId;
  readonly name: string;
  readonly color: Types.HexColor;
  readonly description: string | null;
  readonly inLibrary: boolean;
  readonly endorsed: boolean;
  readonly icon: Types.IconType | null;
};

export type CategoryFragment = {
  readonly __typename: "Category";
  readonly id: c.CategoryId;
  readonly name: string;
  readonly color: Types.HexColor;
  readonly description: string | null;
};

export const StatusFragmentDoc = /*#__PURE__*/ gql`
  fragment StatusFragment on Status {
    id
    name
    color
    description
    inLibrary
    endorsed
    icon
  }
`;
export const CategoryFragmentDoc = /*#__PURE__*/ gql`
  fragment CategoryFragment on Category {
    id
    name
    color
    description
  }
`;
